import { apiGet, apiPost, apiPut } from '../../lib/apiClient'
import type {
  SelectionSetManifest,
  SelectionSetSummary,
  SelectionSetVersion,
  SelectionSetDiff,
} from '@stride/shared'
import type {
  ISelectionSetService,
  SaveSelectionSetParams,
  UpdateSelectionSetParams,
} from './ISelectionSetService.interface'

/** Thin HTTP adapter over /api/selection-sets (Azure Table-backed, no git). */
export class HttpSelectionSetService implements ISelectionSetService {
  list(): Promise<SelectionSetSummary[]> {
    return apiGet<SelectionSetSummary[]>('/api/selection-sets')
  }

  get(slug: string, version?: number): Promise<SelectionSetManifest> {
    const qs = version !== undefined ? `?version=${encodeURIComponent(String(version))}` : ''
    return apiGet<SelectionSetManifest>(`/api/selection-sets/${encodeURIComponent(slug)}${qs}`)
  }

  save(params: SaveSelectionSetParams): Promise<{ slug: string; version: number }> {
    return apiPost<{ slug: string; version: number }>('/api/selection-sets', params)
  }

  update(slug: string, params: UpdateSelectionSetParams): Promise<{ slug: string; version: number }> {
    return apiPut<{ slug: string; version: number }>(`/api/selection-sets/${encodeURIComponent(slug)}`, params)
  }

  versions(slug: string): Promise<SelectionSetVersion[]> {
    return apiGet<SelectionSetVersion[]>(`/api/selection-sets/${encodeURIComponent(slug)}/versions`)
  }

  diff(slug: string, base: number, head: number): Promise<SelectionSetDiff> {
    const qs = `?base=${encodeURIComponent(String(base))}&head=${encodeURIComponent(String(head))}`
    return apiGet<SelectionSetDiff>(`/api/selection-sets/${encodeURIComponent(slug)}/diff${qs}`)
  }
}
